<mat-list class="wrapper-product-attributes">
  <mat-list-item>
    <span matListItemTitle>Art.-Nr.: {{ product().sku }}</span>
    <span matListItemLine class="end-user-price">
      <ng-template let-prices uiProductPriceVisibility [prices]="product().prices">
        <span>{{ prices.endUserPriceLabel }}:&nbsp;</span>
        @if (prices.endUser; as endUserPrice) {
          <ui-product-prices-formatter
            [price]="endUserPrice"
            [showThousandthsPlace]="false"
          ></ui-product-prices-formatter>
        } @else {
          <span>k. A.</span>
        }
      </ng-template>
    </span>
  </mat-list-item>

  @if (showAdditionalData()) {
    <mat-list-item>
      <span matListItemTitle>EAN: {{ product().details.gtin }}</span>
      <span matListItemLine>
        @if (product().details.gtinPackaging) {
          Stangen-EAN: {{ product().details.gtinPackaging }}
        }
      </span>
    </mat-list-item>
  }

  <mat-list-item>
    <span matListItemTitle>VE: {{ product().details.packagingUnit }}</span>
    <span matListItemLine>
      @if (product().details.articleNumberStable && showAdditionalData()) {
        Stab. Art.-Nr.: {{ product().details.articleNumberStable }}
      }
    </span>
  </mat-list-item>
</mat-list>
